export enum SearchTabsEnum {
  ALL = 'all',
  POSTS = 'posts',
  USERS = 'users',
  PROJECTS = 'projects',
  EVENTS = 'events',
  PLACES = 'places',
  MARKETPLACE = 'marketplace',
}
